import axios from "axios";
import authHeader from "./auth-header";
import authService from "./auth.service";
import { API_URL } from "../Config/api";

const USER_API_URL = `${API_URL}/user/`;

class UserService {
  getPublicContent() {
    return axios.get(USER_API_URL + "all");
  }

  getUserProfile() {
    return true;
    //  return axios.get(USER_API_URL + 'profile', { headers: authHeader() });
  }

  getAdminProfile() {
    return axios
      .get(`${API_URL}/dashboard/perfil`)
      .catch(function (error) {
        console.log(error);
      });
  }

  async updateProfile(accessToken, user_id, post_data) {
    const response = await axios
      .post(
        `${API_URL}/update-profile`,
        {
          user_id,
          post_data,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + accessToken,
          },
        }
      )
      .catch(function (error) {
        if (error.response) {
          // Request made and server responded
          return error.response;
        }
      });

    let storage = JSON.parse(localStorage.getItem("user"));

    if (response.data) {
      storage["user"] = response.data.user;
      localStorage.setItem("user", JSON.stringify(storage));
    }

    return response;
  }
}

export default new UserService();
